import { useEffect, useState } from 'react';
import AppLayout from '../Layouts/AppLayout';
import { Progress } from '@/components/ui/progress';
import CardCompradorVendedor from '../CardCompradorVendedor';
import HeaderTramite from '../HeaderTramite';
import CardEscritura from '../CardEscritura';
import TramiteTabs from '../TramiteTabs';
import TramiteActions from '../TramiteActions';
import {
  Navigate,
  useNavigate,
  useLocation
} from 'react-router-dom';
import { useAuth } from '@/auth';
import { checkAllPermissions, PERMISSIONS } from '@/auth/permissions';
import { useDashboard } from '../../hooks/useDashboard';
import TramiteStatusSummary from '../TramiteStatusSummary/TramiteStatusSummary';
import { TRAMITE_LABELS } from '@/common/constants';
import WhatsAppQuickGroupModal from '../WhatsAppQuickGroupModal';


const Dashboard = () => {
  // Controlo que venga el parametro de tramite por ruta
  const { state } = useLocation();
  const { user } = useAuth();
  const userPermissions = user?.permissions ?? [];
  const canSendWhatsApp = checkAllPermissions(userPermissions, [PERMISSIONS.SEND_WHATSAPP.name]);
  const navigate = useNavigate();
  const [quickGroupModal, setQuickGroupModal] = useState<'vendedores' | 'compradores' | null>(null);

  if (!state?.tramite) return <Navigate to="/" />;

  // Obtener el tab activo desde el state (para navegación directa a comentarios)
  const defaultTab = state?.activeTab || 'comentarios';

  const {
    tramite, loading, fetchData, finalizarTramite, eliminarTramite,
    eliminandoTramite,
    finalizandoTramite
  } = useDashboard({
    tramiteId: state.tramite.id
  });

  const handleChangeEscritura = (e: any) => {
    // e = tramite objeto cambiado
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleClickFinalizar = () => {
    finalizarTramite();
  };

  const handleClickEliminar = () => {
    eliminarTramite();
  };

  return (
    <AppLayout
      title="Panel de trámite"
      // Quien navegue hasta acá puede indicar a dónde volver con `state.from`
      // (por ejemplo, el presupuesto que se importó en esta escritura). Sin eso,
      // el botón vuelve al listado de escrituras como siempre.
      prevAction={() => navigate(state?.from ?? '/')}
    >
      {loading && <Progress value={undefined} className="h-1" />}
      {!loading && (
        <>
          <HeaderTramite
            tareasTramite={tramite}
            onTareasChanged={() => fetchData({ silent: true })}
            tramiteVivo={tramite}
            onBloqueoChanged={() => fetchData({ silent: true })}
            onArchivadoChanged={() => fetchData({ silent: true })}
          />

          <div className="grid grid-cols-1 2xl:grid-cols-3 gap-6 my-2">
            <CardCompradorVendedor
              data={tramite.vendedores}
              title={TRAMITE_LABELS.TRANSFERENTES}
              tramiteId={tramite.id}
              parameterName="vendedoresTitle"
              canSendWhatsAppQuick={canSendWhatsApp}
              onSendWhatsAppQuick={() => setQuickGroupModal('vendedores')}
            />
            <CardCompradorVendedor
              data={tramite.compradores}
              title={TRAMITE_LABELS.ADQUIRIENTES}
              tramiteId={tramite.id}
              parameterName="compradoresTitle"
              canSendWhatsAppQuick={canSendWhatsApp}
              onSendWhatsAppQuick={() => setQuickGroupModal('compradores')}
            />
            <CardEscritura
              tramite={tramite}
              onChange={handleChangeEscritura}
              onTramiteUpdated={fetchData}
            />
          </div>

          {checkAllPermissions(userPermissions, [PERMISSIONS.VIEW_STATUS_SUMMARY.name]) && (
            <TramiteStatusSummary tramite={tramite} />
          )}

          <TramiteTabs
            tramite={tramite}
            defaultTab={defaultTab}
          />



          {checkAllPermissions(userPermissions, [PERMISSIONS.MANAGE_TRAMITES.name]) && (
            <TramiteActions
              tramite={tramite}
              onEliminar={handleClickEliminar}
              onFinalizar={handleClickFinalizar}
              loadingEliminar={eliminandoTramite}
              loadingFinalizar={finalizandoTramite}
            />
          )}
          {canSendWhatsApp && quickGroupModal && (
            <WhatsAppQuickGroupModal
              open={!!quickGroupModal}
              onOpenChange={(open) => {
                if (!open) {
                  setQuickGroupModal(null);
                }
              }}
              tramite={tramite}
              recipientGroup={quickGroupModal}
              onTramiteUpdated={fetchData}
            />
          )}
        </>
      )}
    </AppLayout>
  );
}

export default Dashboard;
